import { DynamicInput, IDynamicInputOptions } from "../../dynamic-forms/inputs/dynamic-input.model";
import { CustomPendCheckboxGroupComponent } from "./custom-pend-checkbox-group.component";

export interface ICheckboxGroupOptions extends IDynamicInputOptions {
  options?: { text: string; value: string | number }[];
}

export class CustomPendCheckboxGroup extends DynamicInput implements ICheckboxGroupOptions {
  filter: boolean;
  options: any[];
  hidden: boolean;

  readonly controlType = "checkbox-group";
  readonly componentType = CustomPendCheckboxGroupComponent;


  constructor(options: ICheckboxGroupOptions = {}) {
    super(options);
    this.options = options.options || [];
  }
}
